import { render, staticRenderFns } from "./error.vue?vue&type=template&id=19cd9a97&scoped=true"
import script from "./error.vue?vue&type=script&lang=js"
export * from "./error.vue?vue&type=script&lang=js"
import style0 from "./error.vue?vue&type=style&index=0&id=19cd9a97&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cd9a97",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19cd9a97')) {
      api.createRecord('19cd9a97', component.options)
    } else {
      api.reload('19cd9a97', component.options)
    }
    module.hot.accept("./error.vue?vue&type=template&id=19cd9a97&scoped=true", function () {
      api.rerender('19cd9a97', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/error/error.vue"
export default component.exports